var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"label":_vm.$t('addShooting.selectStamp'),"return-object":"","item-value":"id","item-text":"name","items":_vm.stamps,"clearable":"","rules":_vm.select},on:{"input":_vm.update},model:{value:(_vm.selectedStamp),callback:function ($$v) {_vm.selectedStamp=$$v},expression:"selectedStamp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }